// Minimal mustache renderer for the Content Recommendations delivery templates.
// Supports {{#section}}...{{/section}} (truthy / array iteration),
// {{^section}}...{{/section}} (inverted) and {{variable}} (HTML-escaped) —
// the full feature set used by the templates authored on the CMS block.

const escapeHtml = (value: any): string => {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

// walk the context stack from innermost to outermost, like mustache does
const lookup = (stack: any[], name: string): any => {
    for (let i = stack.length - 1; i >= 0; i -= 1) {
        const context = stack[i];
        if (context && typeof context === 'object' && name in context) {
            return context[name];
        }
    }
    return undefined;
};

const SECTION_PATTERN = /\{\{([#^])\s*([\w.]+)\s*\}\}([\s\S]*?)\{\{\/\s*\2\s*\}\}/g;
const VARIABLE_PATTERN = /\{\{\s*([\w.]+)\s*\}\}/g;

const render = (template: string, stack: any[]): string => {
    const withSections = template.replace(SECTION_PATTERN, (match, type, name, inner) => {
        const value = lookup(stack, name);
        const truthy = Array.isArray(value) ? value.length > 0 : !!value;

        if (type === '^') {
            return truthy ? '' : render(inner, stack);
        }
        if (!truthy) {
            return '';
        }
        if (Array.isArray(value)) {
            return value.map(item => render(inner, stack.concat([item]))).join('');
        }
        return render(inner, stack.concat([typeof value === 'object' ? value : {}]));
    });

    return withSections.replace(VARIABLE_PATTERN, (match, name) => escapeHtml(lookup(stack, name)));
};

export const renderMustache = (template: string, view: any): string => render(template || '', [view]);
